<div class="sp-dialog__max-width-m sp-dialog__min-width">
    <div class="sp-padding__x2" *ngIf="!is_setting_note_running">
        <h3>{{ 'UNPAID.SET_NOTE_CTA' | translate }}</h3>
        <div class="sp-color__accent sp-padding">
            <div *ngIf="!editing" class="sp-row__align">
                <mat-icon>lock</mat-icon>
            </div>
            <div *ngIf="editing" class="sp-row__align">
                <mat-icon>edit</mat-icon>
                {{ 'UNPAID.EDITING' | translate }}
            </div>
        </div>
        <form
                [formGroup]="unpaid_set_note_form_group"
                class="sp-margin__top-x2 sp-row__space sp-wrap">
            <mat-form-field
                    class="sp-width__full"
                    appearance="fill"
                    color="accent">
                <mat-label>
                    {{ 'UNPAID.NOTE_LABEL' | translate }}
                </mat-label>
                <textarea matInput
                          type="text"
                          formControlName="note"
                          style="min-height: 150px"
                          [readonly]="!editing"
                          [errorStateMatcher]="error_matcher"
                ></textarea>
            </mat-form-field>
            <div class="sp-margin__top-x4 sp-width__full">
                <app-shared-button
                        class="sp-width__full"
                        *ngIf="editing"
                        icon='save'
                        [cta]="'UNPAID.SAVE_NOTE_CTA'"
                        [is_disabled]="!isFormValid()"
                        (button_click)="onSetNoteClick()"></app-shared-button>
                <app-shared-button
                        mat-icon-button
                        class="sp-width__full"
                        icon='edit'
                        *ngIf="!editing"
                        [cta]="'UNPAID.START_EDITING_NOTE_CTA' | translate "
                        (click)="startEditing()">
                </app-shared-button>
            </div>
        </form>
    </div>
    <div
            *ngIf="is_setting_note_running"
            class="sp-column__center sp-width__full sp-padding__x2">
        <mat-spinner
                color="accent"
                diameter="40"></mat-spinner>
        <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
    </div>
</div>
